import { convertCartItemToGAItem, getTotalValue, getItemPriceAndDiscount, getLoationId } from "@/utils/track/common"
export const trackViewCart = store => {
  if (window?.dataLayer) {
    window.dataLayer.push({
      event: "view_cart",
      ecommerce: {
        currency: "HKD",
        value: getTotalValue(getCartItems(store)),
        items: getCartItems(store)
      }
    })
  }
}

export const trackBeginCheckout = (store, coupons = [], totalPrice) => {
  if (window?.dataLayer) {
    window.dataLayer.push({
      event: "begin_checkout",
      ecommerce: {
        currency: "HKD",
        value: totalPrice / 100,
        coupon: coupons.join(","),
        items: getCartItems(store, true)
      }
    })
  }
}
export const trackAddToCart = item => {
  if (window?.dataLayer) {
    item.quantity = item.quantity || 1
    window.dataLayer.push({
      event: "add_to_cart",
      ecommerce: {
        currency: "HKD",
        value: item.quantity * getItemPriceAndDiscount(item).price,
        items: [convertCartItemToGAItem(item, true)]
      }
    })
  }
}
export const trackRemoveFromCart = item => {
  if (window?.dataLayer) {
    item.quantity = item.quantity || 1
    window.dataLayer.push({
      event: "remove_from_cart",
      ecommerce: {
        currency: "HKD",
        value: item.quantity * getItemPriceAndDiscount(item).price,
        items: [convertCartItemToGAItem(item, true)]
      }
    })
  }
}

export const trackSelectItem = (item, redirect) => {
  if (window?.dataLayer) {
    window.dataLayer.push({
      event: "select_item",
      ecommerce: {
        items: [convertCartItemToGAItem(item, true)]
      },
      eventCallback: function () {
        if (redirect) redirect()
      }
    })
  }
}

export const handleChangeCartNumber = (currentNumber, oldNumber, item) => {
  try {
    if (currentNumber > oldNumber) {
      trackAddToCart({ ...item, quantity: currentNumber - oldNumber })
    } else {
      trackRemoveFromCart({ ...item, quantity: oldNumber - currentNumber })
    }
  } catch (error) {
    console.error(error)
  }
}

export const trackAddShippingInfo = (items, coupons = [], totlePrice, address) => {
  if (window?.dataLayer) {
    window.dataLayer.push({
      event: "add_shipping_info",
      ecommerce: {
        currency: "HKD",
        value: totlePrice / 100,
        coupon: coupons.join(",") || "na",
        shipping_tier: "next day delivery",
        shipping_address: address.Address2,
        items: items.map(convertCartItemToGAItem)
      }
    })
  }
}

export const trackRedemptionOrGift = (changedWares, wares, itemType) => {
  try {
    const changedWare = changedWares.filter(item => item.beforeCount !== item.count)
    if (changedWare.length === 0) return
    const result = changedWares.map(item => {
      const ware = wares.find(ware => ware.id === item.id) || {}
      return {
        ...ware,
        ...item,
        itemType,
        parentId: itemType,
        layoutName: itemType
      }
    })
    result.forEach(item => {
      handleChangeCartNumber(item.count, item.beforeCount || 0, item)
    })
  } catch (error) {
    console.error(error)
  }
}

// 获取围栏内主门店
export const getRangeStore = data => {
  // 围栏内数据(storeGroupType === 'Range')
  const rangeStoreGroup = (data.storeGroupList || []).find(item => item.storeGroupType === "Range") || {}
  const storeList = rangeStoreGroup.storeList || []

  return storeList
}

// 获取围栏内从门店列表
export const getRangeSlaveStoreList = data => {
  // 围栏内数据(storeGroupType === 'Range')
  const rangeStoreGroup = (data.storeGroupList || []).find(item => item.storeGroupType === "Range") || {}
  const slaveStoreList = rangeStoreGroup.otherStoreList || []

  return slaveStoreList
}

const handlePromotion = (promotion, index) => {
  const { commonReqParams } = JSON.parse(localStorage.getItem("commData"))
  return {
    item_id: promotion.promotionId,
    item_name: promotion.promotionDisplay?.proTag,
    item_category: "na",
    item_category2: "na",
    item_category3: "na",
    item_category4: commonReqParams.storeId,
    item_category5: "0",
    price: promotion.itemSubtotalPrice,
    discont: promotion.promotionAmount,
    coupon: "na",
    location_id: getLoationId(),
    index
  }
}

const handleItem = (item, selectChecked) => {
  let result = []
  if (item.promotionList && item.promotionList.length > 0 && item.wareList?.[0]?.promotionCount < 1) {
    if (selectChecked && item.wareList?.[0]?.checked === 0) return []
    const promotionId = item.promotionList[0].promotionId
    item.wareList?.forEach(ware => {
      ware.wareNameWithPromotionId = `${promotionId} ${ware.wareName}`
      ware.wareIdWithPromotionId = `${promotionId} ${ware.sku || ware.skuId}`
    })
  }

  if (selectChecked) {
    result = result.concat((item.wareList || []).filter(item => item.checked === 1).map(convertCartItemToGAItem))
  } else {
    result = result.concat((item.wareList || []).map(convertCartItemToGAItem))
  }
  return result
}
const getItemsfromStore = (storeList, selectChecked) => {
  let result = []
  storeList.forEach(store => {
    store.itemGroupList.forEach(group => {
      if (![2, 3, 4].includes(group.itemGroupType)) return
      group.itemList.forEach(item => {
        if (item.itemType === 3) return
        result = result.concat(handleItem(item, selectChecked))
      })
    })
  })
  return result
}

// TODO promotion2.0 未完成
const getCartItems = (store, selectChecked = false) => {
  if (Array.isArray(store)) {
    return store.map(convertCartItemToGAItem)
  }
  const storeItems = getItemsfromStore(getRangeStore(store), selectChecked)
  const otherItems = getItemsfromStore(getRangeSlaveStoreList(store), selectChecked)
  return storeItems.concat(otherItems)
}
